import { ROUTES } from '@constants';
import QueryKeys from '@constants/query-keys';
import { Axios as api } from '@helpers';
import { CCModelDetailsType } from '@services';
import { useQuery, UseQueryOptions } from 'react-query';
import { useLocation } from 'react-router-dom';

export type SocialUserInfoResponse = CCModelDetailsType;

export const getSocialUserInfo = async (id: string): Promise<SocialUserInfoResponse> => {
  const response = await api.get<SocialUserInfoResponse>(`/admin/accounts/content-creator/${id}`);
  return response.data;
};

export const getSocialUserInfoQueryOptions = (
  id: string,
): UseQueryOptions<SocialUserInfoResponse> => {
  return {
    queryKey: [QueryKeys.socialUserInfo, id],
    queryFn: () => getSocialUserInfo(id),
  };
};

export const getBusinessSocialUserInfo = async (
  id: string,
  assetId?: string,
): Promise<SocialUserInfoResponse> => {
  const response = await api.get<SocialUserInfoResponse>(`/admin/accounts/${id}/models/${assetId}`);
  return response.data;
};

export const getBusinessSocialUserInfoQueryOptions = (
  id: string,
  assetId?: string,
): UseQueryOptions<SocialUserInfoResponse> => {
  return {
    queryKey: [QueryKeys.socialBusinessUserInfo, id, assetId],
    queryFn: () => getBusinessSocialUserInfo(id, assetId),
  };
};

type UseUsersOptions = {
  id: string;
  assetId?: string;
  queryConfig?: UseQueryOptions<SocialUserInfoResponse>;
};

export const useSocialUserInfo = ({ id, assetId, queryConfig }: UseUsersOptions) => {
  const { pathname } = useLocation();

  const isBusiness = pathname.includes(`${ROUTES.AssetAccount}/business`);

  const params = isBusiness
    ? getBusinessSocialUserInfoQueryOptions(id, assetId)
    : getSocialUserInfoQueryOptions(id);

  return useQuery({
    ...params,
    ...queryConfig,
  });
};
